<template>
  <div class="counterstable">
    <enfold-ucd>
      <template slot="up">
        <div class="topcon">
          <popovers :content="$t('crl2')">
            <div class="c-u-left" @click="deletes"></div>
          </popovers>
          <div class="c-u-right">
            <div class="search_input">
              <el-input v-model="key_word" :placeholder="$t('terminal.keyWord')" size="mini"
                @keyup.enter.native="search">
                <i slot="suffix" class="el-icon-search" @click="search"></i>
              </el-input>
            </div>
          </div>
        </div>
      </template>
      <template slot="center">
        <el-table style="width: 100%" ref="multipleTable" :data="counters_data" height="100%"
          @selection-change="selectionLineChangeHandle" :row-key="getRowKey" v-loading="loading">
          <el-table-column type="selection" :reserve-selection="true" align="center"></el-table-column>
          <el-table-column prop="publish_no" :label="$t('review.singleNo')" width="220px" sortable
            show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.publish_no || scope.row.publish_name }}
            </template>
          </el-table-column>
          <el-table-column prop="gn" :label="$t('review.group')" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('schedule.releaseType')">
            <template slot-scope="scope">
              <template v-if="scope.row.publish_type === 1">{{ $t('schedule.releaseNow') }}</template>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" :label="$t('review.createTime')" sortable width="180px"></el-table-column>
          <el-table-column prop="publish_user" :label="$t('review.publisher')" width="160px">
            <template slot-scope="scope">
              {{ scope.row.user_name ? scope.row.user_name.substring(0, scope.row.user_name.indexOf('&')) : '--' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('schedule.review')" sortable>
            <template slot-scope="scope">
              <StatusValue :text="getPlayStateRemark(scope.row.publish_state)" :status="scope.row.publish_state" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('schedule.operate')">
            <template slot-scope="scope">
              <div style="display: flex;">
                <popovers :content="$t('schedule.detail')">
                  <img class="con-img" src="@/assets/images/public/public_detail.png"
                    @click="handleDetail(scope.row)" />
                </popovers>
                <popovers :content="$t('schedule.delete')">
                  <img class="con-img" src="@/assets/images/public/public_delete.png"
                    @click="handleDelete(scope.row)" />
                </popovers>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="down">
        <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
        <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('crl2')">
          <div class="dd-dialog">{{ $t('crl3') }}</div>
        </del-dialog>
      </template>
    </enfold-ucd>
    <counters-check class="counters-check" :title="$t('schedule.detail')" :isVisible="mtCheckVisible"
      :current_detail="current_detail" :deviceList="deviceList" :scheduleList="scheduleList"
      :isAppend="true" :isReview="false"
      @closeCheck="closeCheck" @updateData="getCountersList"></counters-check>
  </div>
</template>

<script>
import EnfoldUcd from '@/components/basics/EnfoldUCD'
import Pagination from '@/components/basics/Pagination'
import DelDialog from './children/DelDialog.vue'
import Popovers from "@/components/basics/Popover";
import StatusValue from '@/components/basics/StatusValue'
import CountersCheck from '../review/children/CountersCheck.vue'
import { mPagination } from "@/components/basics/mixins";

export default {
  name: "CountersTable",
  components: {
    EnfoldUcd,
    Pagination,
    DelDialog,
    Popovers,
    StatusValue,
    CountersCheck
  },
  mixins: [mPagination],
  props: {
    pagesize: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      counters_data: [],
      loading: false,
      key_word: '',
      fabu_play: null,
      DelDialogVisible: false,
      deleteId: null,
      mtCheckVisible: false,
      current_detail: null,
      deviceList: [],
      scheduleList: [],
    }
  },
  created() {
    this.limit = this.pagesize;
  },
  mounted() {
    this.getCountersList();
  },
  methods: {
    getPlayStateRemark(state) {
      switch (state) {
        case 0:
          return this.$t('schedule.pedReview')
        case 1:
          return this.$t('schedule.noPass')
        case -1:
          return this.$t('schedule.noReview')
        case 2:
          return this.$t('schedule.pass')
        case 3:
          return this.$t('schedule.pass')
        case 10:
          return this.$t('schedule.waitRelease')
        default:
          return this.$t('schedule.expird')
      }
    },
    getRowKey(row) {
      return row.id
    },
    selectionLineChangeHandle(val) {
      this.fabu_play = val
    },
    currentChange(val) {
      this.page = val;
      this.getCountersList();
    },
    search() {
      this.page = 1;
      this.getCountersList();
    },
    deletes() {
      if (this.fabu_play == null || this.fabu_play.length === 0) {
        this.$msg({
          message: this.$t('crl6'),
          type: 'warning'
        })
        return;
      }
      let ids = [];
      this.fabu_play.forEach(ele => {
        (ele.publish_state !== 0) && ids.push(ele.id);
      });
      this.$refs.multipleTable.clearSelection();
      if (ids.length === 0) {
        this.$msg({ type: 'warning', message: this.$t('crl4') });
        return;
      }
      this.deleteId = ids.toString();
      this.DelDialogVisible = true;
    },
    handleDelete(row) {
      if (row.publish_state === 0) {
        this.$msg({ type: 'warning', message: this.$t('crl4') });
        return;
      }
      this.deleteId = row.id;
      this.DelDialogVisible = true;
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm && this.deleteId) {
        this.$http.post("/admin/check/checkCountersDel", { pids: this.deleteId }, (res) => {
          this.$msg({ type: 'success', message: this.$t('crl5') });
          res > 0 && this.getCountersList();
        });
      }
      this.deleteId = null;
      this.DelDialogVisible = false;
    },
    async handleDetail(row) {
      this.current_detail = row;
      this.mtCheckVisible = true;
      await this.$http.post("/admin/publish/cuntersDetail", {
        publish_id: row.id,
      }, res => {
        const { cuntersDetail: { counters_info: countersInfo } } = res;
        const { commands_info, devices_info } = JSON.parse(countersInfo);
        this.scheduleList = commands_info[0].data;
        this.deviceList = devices_info;
      })
    },
    closeCheck() {
      this.mtCheckVisible = false;
    },
    getCountersList() {
      this.loading = true;
      this.$http.post("/admin/check/checkCountersPublishList", {
        limit: this.limit,
        group_id: this.groupId,
        page: this.page,
        publish_state: '0,1,2',
        key_word: this.key_word
      }, data => {
        this.counters_data = data.data ? data.data : [];
        this.current = parseInt(data.total ? data.total : 0);
        this.counters_data.forEach((ele) => {
          if (ele.user_name) {
            ele.publish_user = ele.user_name.substring(0, ele.user_name.indexOf('&'));
          }
        })
        this.loading = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.counterstable {
  width: 101%;
  height: 100%;
  background-color: white;
}

.con-img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.topcon {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.c-u-left {
  height: 30px;
  width: 30px;
  cursor: pointer;
  background-image: url(~@/assets/images/public/public_delete.png);
  background-size: 100%;
  background-position: center;
}

.c-u-right {
  width: 280px;

  /deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }

  /deep/ .el-input__suffix {
    line-height: 30px;
    color: var(--theme-color-customized-1);
    font-size: 16px;
    right: 10px;
  }
}

/deep/ .el-table__header-wrapper {
  .cell {
    font-size: 18px;
    color: var(--theme-color-customized-1);
  }

  .el-table__header tr,
  .el-table__header th {
    padding: 6.5px 0 !important;
  }
}

/deep/ .dd-dialog {
  font-size: 16px;
  padding: 40px 0px;
  text-align: center;
}
</style>
